module.exports = __webpack_public_path__ + "img/80.ff37e6cb.png";